/** Where a change to Kindred data was made. */
export enum KindredChangeSource {
  Edit = "edit",
  Create = "create",
  Targeting = "targeting",
  BulkUpdate = "bulk-update",
  DomainReview = "domain-review",
  BrandDomainApproval = "brand-domain-approval",
  MerchantMapEdit = "merchant-map-edit",
}

export type KindredChangeEntityType =
  | "deal"
  | "coupon"
  | "offer"
  | "brand"
  | "brand_link"
  | "brand_domain"
  | "coupon_target"
  | "merchant_map";

export interface IKindredChangeLogEntry {
  _id: string;
  source: KindredChangeSource;
  /** Short verb, e.g. "update", "remove_domain", "change_brand", "approve". */
  action: string;
  entityType: KindredChangeEntityType;
  entityId: string;
  entityLabel: string | null;
  brandId: string | null;
  brandName: string | null;
  domains: string[];
  actor: string;
  actorName: string | null;
  /** The reason or comment the person gave. */
  comment: string | null;
  /** Groups the rows of one bulk or domain-review run. */
  runId: string | null;
  /** Only the fields that changed. */
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  summary: string | null;
  createdAt: string;
}

export interface IKindredChangeLogFilter {
  entityType?: KindredChangeEntityType;
  entityId?: string;
  brandId?: string;
  domain?: string;
  actor?: string;
  source?: KindredChangeSource;
  runId?: string;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  limit?: number;
}

export interface IKindredChangeLogResponse {
  entries: IKindredChangeLogEntry[];
  total: number;
  page: number;
  limit: number;
  actorOptions: string[];
}
